import { css, cx } from '@emotion/css';
import {Facebook} from 'Shared/frontend/icons/Facebook';
import {Instagram} from 'Shared/frontend/icons/Instagram';
import {Snapchat} from 'Shared/frontend/icons/Snapchat';
import {TikTok} from 'Shared/frontend/icons/TikTok';
import {Twitter} from 'Shared/frontend/icons/Twitter';
import {For, Match, Switch, Show} from 'solid-js';
import { palette } from 'Shared/frontend/SettingsProvider';

const iconStyle = () => css({
	display: 'inline-block',
	position: 'relative',
	verticalAlign: 'middle',
	width: '3.6em',
	height: 'auto',
	padding: '0 0.3em',

	svg: {
		fill: palette().text
	},

	span: {
		background: '#eef',
		position: 'absolute',
		bottom: 0,
		fontSize: '0.8em',
		textAlign: 'center',
		left: '50%',
		transform: 'translate(-50%, 0%)',
		color: '#28363f',
		fontWeight: 'bold',
		padding: '0 1ch'
	}
});


interface ISocialIcons {
	venue: VenueDoc;
}

export function SocialIcons(P:ISocialIcons)
{
	const socialStyle = css(P.styling?.css ?? {});

	return (
		<div class={cx('socialIcons',socialStyle)}>
			<Show when={P.venue.facebook}>
				<a href={`https://www.facebook.com/${P.venue.facebook}`} target='_blank'>
					<div class={iconStyle()}>
						<Facebook />
					</div>
				</a>
			</Show>

			<Show when={P.venue.instagram}>
				<a href={`https://www.instagram.com/${P.venue.instagram}`} target='_blank'>
					<div class={iconStyle()}>
						<Instagram />

						{/* custom hack for townie to enable 2x instagram accounts */}
						<For each={P.venue.otherSocialMedia}>{ other =>
							<Show when={other.title != 'Instagram'}>
								<span>Venue</span>
							</Show>
						}</For>
					</div>
				</a>
			</Show>

			{/* custom hack for townie to enable 2x instagram accounts */}
			<For each={P.venue.otherSocialMedia}>{ other =>
				<Switch>
					<Match when={other?.title != 'Instagram'}>
						<a href={other?.url} target='_blank'>
							<div class={iconStyle()}>
								<Instagram />
								<span>{other.title.replace('Instagram','')}</span>
							</div>
						</a>
					</Match>
					<Match when={true}>
						<a href={other.url} target='_blank'>
							<div class={`${iconStyle()} other`}>{other.title}</div>
						</a>
					</Match>
				</Switch>
			}</For>

			<Show when={P.venue.twitter}>
				<a href={`https://www.twitter.com/${P.venue.twitter}`} target='_blank'>
					<div class={iconStyle()}>
						<Twitter />
					</div>
				</a>
			</Show>

			<Show when={P.venue.tiktok}>
				<a href={`https://www.tiktok.com/${P.venue.tiktok}`} target='_blank'>
					<div class={iconStyle()}>
						<TikTok />
					</div>
				</a>
			</Show>

			<Show when={P.venue.snapchat}>
				<a href={`https://www.snapchat.com/add/${P.venue.snapchat.replace('@','')}`} target='_blank'>
					<div class={iconStyle()}>
						<Snapchat />
					</div>
				</a>
			</Show>
		</div>
	);
}

